module.exports = __webpack_public_path__ + "img/winners3.33060839.svg";